import React from "react";
import IndexPage from "components/pages/IndexPage";
import { SnackbarProvider } from "notistack";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@emotion/react";
import { StylesProvider } from "@mui/styles";
import { CssBaseline } from "@mui/material";

const theme = createTheme();

function App(): JSX.Element {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={5}>
          <CssBaseline />
          <IndexPage />
        </SnackbarProvider>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
